import axios from "axios";
import * as ROUTES from "../../../constants/route";
import Helpers from "../../Helpers";


export default class Functions {
  constructor() {
    this.helpers = new Helpers();
  }

  createFormDataPromise = (name, data, token, uid) => {
    const formData = new FormData();
    formData.append(name, data);
    return axios.post(
      `${ROUTES.FUNCTION_BASE_URL}clients-kyc-kyc/AddKYCImage/${uid}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };

  uploadSelectedFiles = async (uploads, token, uid) => {
    for (const [name, data] of uploads) {
      if (!data) continue;
      try {
        const response = await this.createFormDataPromise(name, data, token, uid);
        if (response.data.ok !== true) throw new Error(response.data.message);
      } catch (error) {
        error.isUploadError = true;
        throw error;
      }
    }
  };

  doAddLongKYC = (
    uid,
    uploadImg,
    additionalInfo,
    pepDeclaration,
    signature,
    fatca
  ) => {
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      let sigSplit = signature.signatureUrl.split(",");
        const toBoolean = (item) => (item === "1" );
      const filteredData = additionalInfo.existingID
        ? {
            work: {
              annualIncomeAmount: additionalInfo.work.annualIncomeAmount,
              businessNature: additionalInfo.work.businessNature,
              nameOfEmployer: additionalInfo.work.nameOfEmployer,
              primaryOccupation: additionalInfo.work.primaryOccupation,
            },
            businessAddress: {
              barangay: additionalInfo.businessAddress.barangay,
              street: additionalInfo.businessAddress.street,
              city: additionalInfo.businessAddress.city,
              province: additionalInfo.businessAddress.province,
              zip: additionalInfo.businessAddress.zip || "n/a",
              country: additionalInfo.businessAddress.country,
            },
            permanentAddress: {
              barangay: additionalInfo.permanentAddress.barangay,
              street: additionalInfo.permanentAddress.street,
              city: additionalInfo.permanentAddress.city,
              province: additionalInfo.permanentAddress.province,
              zip: additionalInfo.permanentAddress.zip || "n/a",
              country: additionalInfo.permanentAddress.country,
            },

                  ...(additionalInfo.ids?.idType
    ? {
        ids: {
          idNumber: "",
          idType: additionalInfo.ids.idType,
          SSS: additionalInfo.ids.SSS || "",
          TIN: additionalInfo.ids.TIN || "",
        },
      }
    : {}),

            PEP: {
              banks: pepDeclaration.banks,
              governmentRelative: toBoolean(pepDeclaration.governmentRelative),
              governmentWork: toBoolean(pepDeclaration.governmentWork),
            },
            FATCA: {
              usPerson: toBoolean(fatca.usPerson),
              usCitizen: toBoolean(fatca.usCitizen),
              usResident: toBoolean(fatca.usResident),
              usAlien: toBoolean(fatca.usAlien),
              usPhone: toBoolean(fatca.usPhone),
              usBorn: toBoolean(fatca.usBorn),
              usAddressResidence: toBoolean(fatca.usAddressResidence),
              usAddressMailing: toBoolean(fatca.usAddressMailing),
              usAccount: toBoolean(fatca.usAccount),
              usPOA: toBoolean(fatca.usPOA),
              usCareOfAddress: toBoolean(fatca.usCareOfAddress),
            },
          }
        : {
            work: {
              annualIncomeAmount: additionalInfo.work.annualIncomeAmount,
              businessNature: additionalInfo.work.businessNature,
              nameOfEmployer: additionalInfo.work.nameOfEmployer,
              primaryOccupation: additionalInfo.work.primaryOccupation,
            },
             permanentAddress: {
              barangay: additionalInfo.permanentAddress.barangay,
              street: additionalInfo.permanentAddress.street,
              city: additionalInfo.permanentAddress.city,
              province: additionalInfo.permanentAddress.province,
              zip: additionalInfo.permanentAddress.zip || "n/a",
              country: additionalInfo.permanentAddress.country,
            },
            businessAddress: {
              barangay: additionalInfo.businessAddress.barangay,
              street: additionalInfo.businessAddress.street,
              city: additionalInfo.businessAddress.city,
              province: additionalInfo.businessAddress.province,
              zip: additionalInfo.businessAddress.zip || "n/a",
              country: additionalInfo.businessAddress.country,
            },

            PEP: {
              banks: pepDeclaration.banks,
              governmentRelative: toBoolean(pepDeclaration.governmentRelative),
              governmentWork: toBoolean(pepDeclaration.governmentWork),
            },
            FATCA: {
              usPerson: toBoolean(fatca.usPerson),
              usCitizen: toBoolean(fatca.usCitizen),
              usResident: toBoolean(fatca.usResident),
              usAlien: toBoolean(fatca.usAlien),
              usPhone: toBoolean(fatca.usPhone),
              usBorn: toBoolean(fatca.usBorn),
              usAddressResidence: toBoolean(fatca.usAddressResidence),
              usAddressMailing: toBoolean(fatca.usAddressMailing),
              usAccount: toBoolean(fatca.usAccount),
              usPOA: toBoolean(fatca.usPOA),
              usCareOfAddress: toBoolean(fatca.usCareOfAddress),
            },
          };
  const formData = new FormData();
  formData.append("req", JSON.stringify(filteredData));
  formData.append("signature", sigSplit[1]);
      this.uploadSelectedFiles(
        [
          ["secondary1", uploadImg.idPhotoFront],
          ["secondary2", uploadImg.idPhotoBack],
          ["PEPDocument", uploadImg.idPEPDeclaration],
        ],
        token,
        uid
      )
        .then(() => {
          return axios.post(
            `${ROUTES.FUNCTION_BASE_URL}clients-kyc-kyc/tier3-kyc/${uid}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        })
 
  .then((res) => {
    resolve(res);
  })
  .catch((err) => {
    if (!err.response?.data?.redirect) {
      this.helpers.handleError(err);
    }
    reject(err);
  });
    });
  };
  doUpdateLongKYC = (
    uid,
    uploadImg,
    additionalInfo,
    pepDeclaration,
    signature,
    fatca
  ) => {
    console.log(additionalInfo)
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      let sigSplit = signature.signatureUrl.split(",");
        const toBoolean = (item) => (item === "1" );
      const filteredData = additionalInfo.existingID
        ? {
            work: {
              annualIncomeAmount: additionalInfo.work.annualIncomeAmount,
              businessNature: additionalInfo.work.businessNature,
              nameOfEmployer: additionalInfo.work.nameOfEmployer,
              primaryOccupation: additionalInfo.work.primaryOccupation,
            },
            businessAddress: {
              barangay: additionalInfo.businessAddress.barangay,
              street: additionalInfo.businessAddress.street,
              city: additionalInfo.businessAddress.city,
              province: additionalInfo.businessAddress.province,
              zip: additionalInfo.businessAddress.zip || "n/a",
              country: additionalInfo.businessAddress.country,
            },

               permanentAddress: {
              barangay: additionalInfo.permanentAddress.barangay,
              street: additionalInfo.permanentAddress.street,
              city: additionalInfo.permanentAddress.city,
              province: additionalInfo.permanentAddress.province,
              zip: additionalInfo.permanentAddress.zip || "n/a",
              country: additionalInfo.permanentAddress.country,
            },

         ...(additionalInfo.ids?.idType
    ? {
        ids: {
          idNumber: "",
          idType: additionalInfo.ids.idType,
          SSS: additionalInfo.ids.SSS || "",
          TIN: additionalInfo.ids.TIN || "",
        },
      }
    : {}),

            PEP: {
              banks: pepDeclaration.banks,
              governmentRelative: toBoolean(pepDeclaration.governmentRelative),
              governmentWork: toBoolean(pepDeclaration.governmentWork),
            },
            FATCA: {
              usPerson: toBoolean(fatca.usPerson),
              usCitizen: toBoolean(fatca.usCitizen),
              usResident: toBoolean(fatca.usResident),
              usAlien: toBoolean(fatca.usAlien),
              usPhone: toBoolean(fatca.usPhone),
              usBorn: toBoolean(fatca.usBorn),
              usAddressResidence: toBoolean(fatca.usAddressResidence),
              usAddressMailing: toBoolean(fatca.usAddressMailing),
              usAccount: toBoolean(fatca.usAccount),
              usPOA: toBoolean(fatca.usPOA),
              usCareOfAddress: toBoolean(fatca.usCareOfAddress),
            },
          }
        : {
            work: {
              annualIncomeAmount: additionalInfo.work.annualIncomeAmount,
              businessNature: additionalInfo.work.businessNature,
              nameOfEmployer: additionalInfo.work.nameOfEmployer,
              primaryOccupation: additionalInfo.work.primaryOccupation,
            },
            businessAddress: {
              barangay: additionalInfo.businessAddress.barangay,
              street: additionalInfo.businessAddress.street,
              city: additionalInfo.businessAddress.city,
              province: additionalInfo.businessAddress.province,
              zip: additionalInfo.businessAddress.zip || "n/a",
              country: additionalInfo.businessAddress.country,
            },

               permanentAddress: {
              barangay: additionalInfo.permanentAddress.barangay,
              street: additionalInfo.permanentAddress.street,
              city: additionalInfo.permanentAddress.city,
              province: additionalInfo.permanentAddress.province,
              zip: additionalInfo.permanentAddress.zip || "n/a",
              country: additionalInfo.permanentAddress.country,
            },
            PEP: {
              banks: pepDeclaration.banks,
              governmentRelative: toBoolean(pepDeclaration.governmentRelative),
              governmentWork: toBoolean(pepDeclaration.governmentWork),
            },
            FATCA: {
              usPerson: toBoolean(fatca.usPerson),
              usCitizen: toBoolean(fatca.usCitizen),
              usResident: toBoolean(fatca.usResident),
              usAlien: toBoolean(fatca.usAlien),
              usPhone: toBoolean(fatca.usPhone),
              usBorn: toBoolean(fatca.usBorn),
              usAddressResidence: toBoolean(fatca.usAddressResidence),
              usAddressMailing: toBoolean(fatca.usAddressMailing),
              usAccount: toBoolean(fatca.usAccount),
              usPOA: toBoolean(fatca.usPOA),
              usCareOfAddress: toBoolean(fatca.usCareOfAddress),
            },
          };
// console.log(filteredData)
      const formData = new FormData();
      formData.append("req", JSON.stringify(filteredData));
      formData.append("signature", sigSplit[1]);
      this.uploadSelectedFiles(
        [
          ["secondary1", uploadImg.idPhotoFront],
          ["secondary2", uploadImg.idPhotoBack],
          ["PEPDocument", uploadImg.idPEPDeclaration],
        ],
        token,
        uid
      )
        .then(() => {
          return axios.post(
            `${ROUTES.FUNCTION_BASE_URL}clients-kyc-kyc/tier3-kyc/${uid}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        })

    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      if (!err.response?.data?.redirect) {
        this.helpers.handleError(err);
      }
      reject(err);
    });
    });
  };

}
